<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số biên bản:
                                    {{ this.createItem.reportNumber }}
                                </p>
                                <div class="font-weight-bold">
                                    Số đề nghị:
                                    {{ this.createItem.requestOrderNumber }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Người tạo biên bản:
                                    {{ this.createItem.userCreateName }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 0px 10px">
                                <v-textarea
                                    outlined
                                    label="Nội dung"
                                    rows="2"
                                    v-model="createItem.content"
                                />
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th width="10%">Tên dịch vụ</th>
                                    <th width="10%">Nội dung dịch vụ</th>
                                    <th width="5%">Đơn vị</th>
                                    <th width="10%">Kích thước</th>
                                    <th width="10%">Số lượng đề xuất</th>
                                    <th width="10%">Số lượng nghiệm thu</th>
                                    <th width="15%">Ngày nghiệm thu</th>
                                    <th width="15%">Nhà cung cấp</th>
                                    <th width="15%">Ghi chú</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr v-if="item.row === 0" :key="index">
                                        <td style="font-weight: bold">{{item.typeName}}</td>
                                        <td colspan="7">Không có dịch vụ</td>
                                    </tr>
                                    <tr v-else :key="index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td style="text-align: center">{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.pack }}</td>
                                        <td style="text-align: center">{{ (item.buyNumberPropose != undefined ? item.buyNumberPropose : 0) | currency }}</td>
                                        <td style="text-align: center">
                                            {{ item.quantity | currency }}
                                            <!-- <c-input-number
                                                min="0"
                                                v-model="lstMaterial[index].quantity"
                                                @keydown="keyProcess"
                                                :id="'input_' + index"
                                                :data-index="index"
                                                style="text-align: center"
                                            /> -->
                                        </td>
                                        <td>
                                            <i-datepicker
                                                v-model="lstMaterial[index].acceptDate"
                                                :minDate="minDate()"
                                            />
                                        </td>
                                        <td>
                                            <v-autocomplete
                                                :items="fomarLstSupplier(lstMaterial[index])"
                                                label="Nhà cung cấp"
                                                v-model="lstMaterial[index].supplyId"
                                                item-value="partnerId"
                                                item-text="partnerName"
                                                clearable
                                            />
                                        </td>
                                        <td>
                                            <v-textarea
                                                rows="2"
                                                v-model="lstMaterial[index].pur_note"
                                            />
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onSave" :disabled="loading">
                        {{ $t("Tạo phiếu") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "AcceptanceReportCreate",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Tạo biên bản nghiệm thu",
            loading: false,
            lstSupplier: [],
            lstMaterial: [],
            lstMaterialFull: [],
            requestOrder: null,
            createItem: {
                areaId: '',
                content: '',
                evalutionDirector: '',
                evalutionEngineer: '',
                reportId: '',
                reportNumber: '',
                reqOrdId: '',
                requestData: '',
                requestOrderNumber: '',
                status: 1,
                userCreateId: '',
                userCreateName: '',
                warehouseId: 0,
            },
        };
    },

    created() {
        let queryParam = this.$route.query;
        // 2: thủ kho;  26: mua hàng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role != 26 && role != 3) {
            this.$router.push({ path: '/importRequest' });
        }
        
        if (queryParam.acceptanceReportId != undefined) {
            this.getAcceptanceReport(queryParam.acceptanceReportId);
        } else {
            this.getRequestOrder();
        }
        
        this.getMaterialFull();
        this.getSuppliers();
        this.getNextCode();
        this.createItem.userCreateId = this.$store.state.auth.user.userId;
        this.createItem.userCreateName = this.$store.state.auth.user.fullName;
    },

    methods: {
        setInput(){
            this.lstMaterial = [...this.lstMaterial]
        },
        onCancel() {
            this.$router.push({ path: '/acceptanceReport', query: this.$route.query });
        },
        onSave() {
            const lstMaterial_tmp = this.lstMaterial;
            const totalQuantity = lstMaterial_tmp.reduce((n, {quantity}) => n + quantity, 0);
            if (parseFloat(totalQuantity) <= 0) {
                message.error("Bạn chưa nhập số lượng nghiệm thu");
                return;
            }
            
            const createItem = this.createItem;
            createItem.requestData = JSON.stringify(lstMaterial_tmp);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/acceptanceReport/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success( this.$t("lang.common.save_success"));
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        getRequestOrder() {
            if (this.$route.params.id) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/requestOrder/detail/" + this.$route.params.id
                    )
                    .then((data) => {
                        if (typeof data == "object") {
                            this.requestOrder = data;
                            this.createItem.reqOrdId = data.reqOrdId;
                            this.createItem.areaId = data.areaId;
                            this.createItem.requestOrderNumber = data.requestNumber;

                            this.getWarehouses(data.areaId);
                            // console.log(data.requestData);
                            const dataRequest = JSON.parse(data.requestData);
                            // console.log(JSON.parse(data.requestData));
                            if (dataRequest) {
                                const lstMaterial = dataRequest.lstMaterial;
                                $.each(lstMaterial, function (k, v) {
                                    lstMaterial[k].quantity = v.buyNumberPropose;
                                });
                                this.lstMaterial = lstMaterial;
                            }
                        }
                    });
            }
        },
        getAcceptanceReport(reportId) {
            if (reportId) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/acceptanceReport/search?pageSize=-1&page=-1", {reportId: reportId}
                    )
                    .then((data) => {
                        console.log(data);
                        if (data.items != undefined && data.items[0] != undefined) {
                            this.createItem = data.items[0];
                            this.lstMaterial = JSON.parse(data.items[0].requestData);
                        }
                    });
            }
        },
        getSuppliers() {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
                    {status: 1}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstSupplier = data.items;
                    }
                });
        },
        getMaterialFull() {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/material/search?pageSize=-1&page=-1", {}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstMaterialFull = data.items;
                    }
                });
        },
        getWarehouses(parentId) {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?pageSize=-1&page=-1&categoryTypeCode=WAREHOUSE",
                    { parentId }
                )
                .then((data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.createItem.warehouseId = data.items[0].categoryId;
                    }
                });
        },
        getNextCode() {
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        "/autoIncrease/getNextCode?type=BBNT&prefix=BBNT/&numberZeroBeforeCodeNumberCode=2&suffix="
                )
                .then((data) => {
                    this.createItem.reportNumber = data;
                });
        },
        keyProcess($event) {
            console.log($event.keyCode);
            let index = parseInt($event.target.getAttribute("data-index"));
            console.log(index);
            let input_id = '';
            switch ($event.keyCode) {
                case 13:
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    } else {
                        $event.target.blur(); 
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (index > 0) {
                        index -= 1;
                        input_id = "input_" + index;
                        var element = document.getElementById(input_id);
                        if (typeof element != "undefined" && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    index += 1;
                    input_id = "input_" + index;
                    console.log(input_id);
                    var element = document.getElementById(input_id);
                    console.log(element);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        fomarLstSupplier(item) {
            let supplier = [];
            if (this.lstSupplier.length > 0 && this.lstMaterialFull.length > 0) {
                const findMat = this.lstMaterialFull.filter(function (v) {
                    return item.materialId == v.materialId;
                });
                if (findMat.length > 0) {
                    const material = findMat[0];
                    const supplyId = ',' + material.supplyId + ',';
                    supplier = this.lstSupplier.filter(function (v) {
                        return supplyId.indexOf(',' + v.partnerId + ',') != -1;
                    });
                }
            }
            return supplier;
        },
    },

    destroyed() {},
};
</script>
